export default {
  CONFIRM: 'CONFIRM_CONFIRM_MODAL',
  CANCEL: 'CANCEL_CONFIRM_MODAL',
  INITIATE: 'INITIATE_CONFIRM_MODAL'
}
